/**
 * 存储token到localStorage，并设置过期时间
 * @param {string} key - 存储的键名（如 'user_token'）
 * @param {string} token - 要存储的token值
 * @param {number} expireTime - 有效期（毫秒），例：7天=7*24*60*60*1000
 */
 export function setTokenWithExpire(key, token, expireTime) {
    // 校验参数合法性
    if (!key || !token || !expireTime) {
      console.error('存储token失败：参数不完整');
      return false;
    }
  
    try {
      const tokenObj = {
        value: token,
        expire: Date.now() + expireTime // 过期时间戳（当前时间+有效期）
      };
      localStorage.setItem(key, JSON.stringify(tokenObj));
      return true; // 存储成功返回true
    } catch (err) {
      console.error('存储token失败：', err);
      return false; // 存储失败返回false
    }
  }
  
  /**
   * 从localStorage读取token，并校验是否过期
   * @param {string} key - 存储的键名
   * @returns {string|null} - 有效token返回值，无效/过期返回null
   */
  export function getTokenWithExpire(key) {
    if (!key) {
      console.error('读取token失败：缺少key参数');
      return null;
    }
  
    const tokenStr = localStorage.getItem(key);
    if (!tokenStr) {
      return null;
    }
  
    try {
      const tokenObj = JSON.parse(tokenStr);
      // 校验过期时间
      if (Date.now() > tokenObj.expire) {
        // 过期：清除无效token
        localStorage.removeItem(key);
        console.warn('token已过期，已自动清除');
        return null;
      }
      return tokenObj.value;
    } catch (err) {
      // 解析失败：清除无效数据
      localStorage.removeItem(key);
      console.error('读取token失败：数据格式异常', err);
      return null;
    }
  }
  
  /**
   * 清除localStorage中的token
   * @param {string} key - 存储的键名
   * @returns {boolean} - 清除成功返回true，失败返回false
   */
  export function removeToken(key) {
    if (!key) {
      console.error('清除token失败：缺少key参数');
      return false;
    }
  
    try {
      localStorage.removeItem(key);
      return true;
    } catch (err) {
      console.error('清除token失败：', err);
      return false;
    }
  }
  
  /**
   * 快捷方法：判断token是否有效（未过期且存在）
   * @param {string} key - 存储的键名
   * @returns {boolean} - 有效返回true，无效返回false
   */
  export function isTokenValid(key) {
    return !!getTokenWithExpire(key);
  }
  
  /**
 * 获取带过期时间的令牌/用户信息
 * @param {String} key 存储的key
 * @returns {Object|null} 包含value和expire的完整对象（方便修改后复用expire）
 */
export function getTokenWithExpireFull(key) {
  try {
    const storeStr = localStorage.getItem(key);
    if (!storeStr) return null;

    const storeData = JSON.parse(storeStr);
    // 仅校验过期，不删除（因为要复用expire）
    const isExpired = Date.now() > storeData.expire;
    return {
      value: isExpired ? null : storeData.value,
      expire: storeData.expire, // 保留原始过期时间
      isExpired
    };
  } catch (error) {
    console.error("获取失败：", error);
    return null;
  }
}

  /**
 * 修改userinfo中的指定字段（保留原有过期时间）
 * @param {Object} updateData 要修改的字段（如{name: '新名称', mobile: '新手机号'}）
 * @returns {Boolean} 是否修改成功
 */
export function updateUserInfo(updateData, key) {
  // 1. 获取原有完整数据（包含expire）
  const fullData = getTokenWithExpireFull(key);
  
  // 校验：信息不存在/已过期则返回失败
  if (!fullData || fullData.isExpired || !fullData.value) {
    console.error("用户信息不存在或已过期");
    return false;
  }

  // 2. 合并原有数据和新字段（仅修改name/mobile，其他字段保留）
  const newUserInfo = {
    ...fullData.value, // 原有所有字段
    ...updateData // 覆盖要修改的字段（name/mobile）
  };

  // 3. 计算剩余过期时间（秒）：原有expire - 当前时间 → 转秒
  const remainExpire = Math.ceil(fullData.expire - Date.now());//Math.ceil((fullData.expire - Date.now()) / 1000);
  
  // 4. 重新存储（复用原有过期时间）
  return setTokenWithExpire(key, newUserInfo, remainExpire);
}